import React from 'react';
export function Footer() {
  return <footer className="py-4 px-4 sm:px-6 bg-brand-plumDark text-center text-brand-blush/75 text-[10px] sm:text-xs" data-id="element-55" data-mp="32wd2qgad7ltj">
      <p className="font-semibold mb-1.5" data-id="element-56" data-mp="3ghc486nrdbqc">© 2026 RHYTHMIC GYM PRO™ — Tutti i Diritti Riservati.</p>
      <p className="leading-snug max-w-2xl mx-auto font-medium mb-2" data-id="element-57" data-mp="32lrmvfnoh1l1">
        Le informazioni e i materiali contenuti in questo sistema rappresentano risorse professionali di supporto
        destinate ad allenatori e insegnanti di ginnastica ritmica qualificati. Non sostituiscono la preparazione
        professionale, il giudizio tecnico o la responsabilità dell&apos;allenatore. Ogni pianificazione, esercizio,
        progressione, programma o strumento deve essere adattato all&apos;età, al livello tecnico, alle capacità
        individuali, agli obiettivi stagionali e alle esigenze specifiche di ogni atleta o gruppo.
      </p>
      <div className="flex justify-center gap-2 sm:gap-3 font-bold tracking-wide" data-id="element-58" data-mp="2eyt7ymf7i1p8">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-59" data-mp="3l9adtjp9964y">
          Termini e Condizioni
        </a>
        <span data-id="element-60" data-mp="3gaz213feglk3">•</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-61" data-mp="3gbr0qn4amzel">
          Privacy Policy
        </a>
        <span data-id="element-62" data-mp="3v9b0nfmc24dw">•</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-63" data-mp="3v5n7ihksvjzp">
          Contatti
        </a>
      </div>
    </footer>;
}